import { useCallback, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import PermissionChangeNotification from '../shared/components/permission/PermissionChangeNotification';
import { usePermissionWatcher } from '../shared/hooks/usePermissionWatcher';
import DesktopSidebar from './sidebar/DesktopSidebar';
import MobileSidebar from './sidebar/MobileSidebar';

function AdminLayout() {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(true);

  const isActive = useCallback(
    (path: string) => {
      return location.pathname === path;
    },
    [location.pathname]
  );

  usePermissionWatcher();

  return (
    <>
      <PermissionChangeNotification />
      <div className='fixed inset-0 flex h-screen overflow-hidden'>
        {/* 사이드바 */}
        <DesktopSidebar
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          isActive={isActive}
        />
        <MobileSidebar
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          isActive={isActive}
        />

        {/* 메인 컨텐츠 영역 */}
        <div className='flex-1 flex flex-col min-w-0 h-full'>
          {/* 헤더 영역 (고정) */}
          <div className='bg-white px-6 py-3 flex-shrink-0 h-16 flex items-center'>
            <div className='flex items-center justify-between w-full'>
              <div className='flex-1' />
            </div>
          </div>

          {/* 헤더와 콘텐츠 사이 구분선 */}
          <div className='border-b border-gray-200 flex-shrink-0' />

          {/* 스크롤 가능한 컨텐츠 영역 */}
          <div
            className='flex-1 overflow-y-auto bg-white'
            style={{ height: 'calc(100vh - 64px)' }}
          >
            <div className='p-4 md:p-8'>
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminLayout;
